import { render, staticRenderFns } from "./SaveMobileAppHealthData.vue?vue&type=template&id=553741c2"
import script from "./SaveMobileAppHealthData.vue?vue&type=script&lang=js"
export * from "./SaveMobileAppHealthData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports